import { Injectable } from '@angular/core';
import { ConfigurationDetailsTreeService as Tree, DetailsTreeNode, TranslateTreeFunc } from '@icc/shared/helpers';
import { SalesDocumentPosition } from '../models/sales-document-position.model';

@Injectable({
    providedIn: 'root'
})
export class StaticPositionDetailsService {
    static staticPositionTypes = ['static', 'group', 'additional'];
    isStaticPosition(position: SalesDocumentPosition) {
        return StaticPositionDetailsService.staticPositionTypes.includes(position.type)
    }


    getPositionTitle(position: SalesDocumentPosition, translate: TranslateTreeFunc): string[] {
        switch (position.type) {
            case 'static':
                return this.staticPositionName(position, translate);
            case 'group':
                return this.groupPositionName(position, translate);
            case 'additional':
                return this.staticPositionName(position, translate);
        }
        return [];
    }

    getDetailsTree(position: SalesDocumentPosition, translate: TranslateTreeFunc): DetailsTreeNode {
        switch (position.type) {
            case 'static':
                return this.staticDetailsTree(position, translate);
            case 'group':
                return this.groupDetailsTree(position, translate);
            case 'additional':
                return this.staticDetailsTree(position, translate);
        }
        return {};
    }

    staticPositionName(position: SalesDocumentPosition, translate: TranslateTreeFunc): string[] {
        return [position?.configuration?.productName];
    }

    groupPositionName(position: SalesDocumentPosition, translate: TranslateTreeFunc): string[] {
        return [''];
    }

    staticDetailsTree(position: SalesDocumentPosition, translate: TranslateTreeFunc): DetailsTreeNode {
        const root = Tree.createRoot();

        if (position.configuration?.index) {
            Tree.pushChild(
                root,
                translate('PRODUCT|Indeks'),
                position.configuration.index
            );
        } else if (position.configuration?.code) {
            Tree.pushChild(
                root,
                translate('PRODUCT|Index'),
                position.configuration.code
            );
        }
        if (position.configuration?.productName) {
            Tree.pushChild(
                root,
                translate('PRODUCT|Nazwa produktu'),
                position.configuration?.productName
            );
        }
        if (position.configuration?.unitName || position.configuration?.unitFactorDesc) {
            Tree.pushChild(
                root,
                translate('PRODUCT|Jednostka produktu'),
                position.configuration?.unitName ? position.configuration?.unitName : position.configuration?.unitFactorDesc
            );
        }
        return root;
    }

    groupDetailsTree(position: SalesDocumentPosition, translate: TranslateTreeFunc): DetailsTreeNode {
        const root = Tree.createRoot();
        return root;
    }

}
